import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { RiDeleteBin5Line } from "react-icons/ri";
import { GrFormAdd, GrFormSubtract } from "react-icons/gr";
import { MdOutlineEdit } from "react-icons/md";
import StorageService from "utils/StorageServices/StorageServices";
import { deleteChartOfAccount, getChartOfAccountDetails } from "_services/accountingServices/accountingServices";
import { ButtonHeading } from "components";
import { AddChartAccountModal } from "modals";
import './chartOfAccount.css';
import Loading from "pages/Loading";

const ChartOfAccount = () => {

    const company_id = StorageService.getCompanyId();
    const [modalShow, setModalShow] = useState({ boolean: '', name: '', });
    const [consignorKey, setConsignorKey] = useState('')
    const location = useLocation()
    const [deleteDisabled, setDeleteDisabled] = useState(false)

    const [isOpen, setIsOpen] = useState(false)
    const [chartOfAccountList, setChartOfAccountList] = useState([])

    const [openIndex, setOpenIndex] = useState(null);
    const [mainIndex, setMainIndex] = useState(null);
    const [selectedValue, setSelectedValue] = useState({
        cat_name: "",
        sub_cat_name: "",
        account_name: "",
        code: "",
        desc: "",
        is_attachment: "",
        is_manual: "",
    });
    const [editForm, setEditForm] = useState({
        account_id: '',
        category_id: '',
        sub_category_id: '',
        name: "",
        code: "",
        desc: "",
        parent_account_id: '',
        is_manual: 1,
        is_attachment: 1,
        company_id: company_id
    })


    const modaOpenClose = async (val) => {
        await setModalShow({ ...modalShow, trueFalse: val.trueFalse, name: val.name })
    }

    const handleClicOpenModal = (e) => {
        // setOpen(true)
        e.preventDefault();
        modaOpenClose({ trueFalse: true, name: "addplan" })

    };

    useEffect(() => {
        // getAccountListFun()
        getChartOfAccounts()
    }, [])

    // const getAccountListFun = async () => {
    //     try {

    //         const res = await dispatch(getAccountList())
    //         if (res.payload.responseCode === 200) {
    //             // setAccountList(res.payload.data)

    //         } else {
    //             toast.error(res?.payload?.responseMessage)
    //         }

    //     } catch (error) {
    //         toast.error(error)
    //     }
    // }

    const getChartOfAccounts = async () => {
        try {

            const res = await getChartOfAccountDetails({ company_id: company_id })

            if (res.responseCode === 200) {
                setChartOfAccountList(res.data.ChartOfAccount)
            } else {
                toast.error(res?.responseMessage)
            }
        } catch (error) {
            // toast.error(error)
        }

    }

    const chartOfAccountDeleteFunction = async (data) => {
        try {
            setDeleteDisabled(true);
            const res = await deleteChartOfAccount({
                account_id: data,
            });
            if (res.responseCode === 200) {
                getChartOfAccounts();
                toast.success(`${res?.responseMessage}`);
                setDeleteDisabled(false);
            } else {
                toast.error(res?.responseMessage);
                setDeleteDisabled(false);
            }
        } catch (error) {
            toast.error(error);
            setDeleteDisabled(false);
        }
    };
    // const updateChartOfAccountsFunction = async (data) => {
    //     try {

    //         if (editForm.category_id && editForm.sub_category_id && editForm.account_id && editForm.name) {
    //             const res = await updateChartOfAccount(editForm)
    //             if (res.payload.data.responseCode === 200) {
    //                 getChartOfAccounts()
    //                 setIsOpen(false)
    //                 setEditForm({
    //                     account_id: '',
    //                     category_id: '',
    //                     sub_category_id: '',
    //                     name: "",
    //                     code: "",
    //                     desc: "",
    //                     parent_account_id: '',
    //                     is_manual: 1,
    //                     is_attachment: 1,
    //                     company_id: company_id
    //                 })
    //                 toast.success(res?.payload?.data?.responseMessage)
    //             } else {
    //                 toast.error(res?.payload?.data?.responseMessage)
    //             }
    //         } else {
    //             toast.error("Account Name Required ")
    //         }

    //     } catch (error) {
    //         toast.error(error)
    //     }
    // }


    const handleEdit = async (category_id, sub_category_id, account_id, selecteValue) => {
        setIsOpen(true)
        setEditForm(prevState => ({
            ...prevState,
            category_id: category_id,
            sub_category_id: sub_category_id,
            account_id: account_id,

        }));
        if (selecteValue) {
            setSelectedValue(prevState => ({
                ...prevState,
                cat_name: selecteValue.cat_name,
                sub_cat_name: selecteValue.sub_cat_name,
                account_name: selecteValue.account.name,
                code: selecteValue.account.code,
                desc: selecteValue.account.desc,
                is_attachment: selecteValue.account.is_attachment,
                is_manual: selecteValue.account.is_manual,
            }));
            setEditForm(prevState => ({
                ...prevState,
                name: selecteValue.account.name,
                code: selecteValue.account.code,
                desc: selecteValue.account.desc,
                parent_account_id: selecteValue.account.id,
                is_manual: selecteValue.account.is_manual,
                is_attachment: selecteValue.account.is_attachment,

            }));
        }

    }

    const [openIndices, setOpenIndices] = useState({});
    const toggleClass = (index, subIndex) => {
        const isOpen = (openIndices[index] || []).includes(subIndex);

        setOpenIndices(prevState => ({
            ...prevState,
            [index]: isOpen
                ? (prevState[index] || []).filter(idx => idx !== subIndex)
                : [...(prevState[index] || []), subIndex]
        }));
    };
    const getLengt = (data) => {
        const lengths = data.filter((item, ind) => item.status === 1)
        return lengths.length
    }

    // const [show, setShow] = useState(false);

    // let AddChartOfAccountModal = {
    //     isOpen: show,
    //     closeModal: (e) => setShow(false),
    //     modalMainClass: "_dashCommon_Modal _mdModal",
    //     modalTitle: "Add Account",
    //     // headerPart: true,
    //     footerPart: true,
    //     submitTitle: "Add Account",
    // }

    let AddChartOfAccountModal = {
        isOpen: isOpen,
        chartOfAccountList: chartOfAccountList,
        isApiCall: () => getChartOfAccounts(),
        closeModal: (e) => setIsOpen(false),
        modalMainClass: "_dashCommon_Modal _mdModal",
        modalTitle: "Add Chart Of Account",
        // headerPart: true,
        footerPart: true,
        submitTitle: "Add Chart Of Account",
    }

    const toggleClasses = (uniqueKey) => {
        setOpenIndices((prev) => ({
            ...prev,
            [uniqueKey]: !prev[uniqueKey], // Toggles between true/false/undefined
        }));
    };

    const renderNestedChildren = (
        children,
        category,
        subItem,
        parentIndex,
        childIndex
    ) => {
        return (
            <ul className="subCategory">
                {children.map((child, index) =>
                    child.is_deleted === 0 ? (
                        <li
                            key={index}
                            className={`child_item ${child?.children?.length > 0 ? "no-marker" : ""
                                }`}
                        >
                            <div className="subCategory_item_container">
                                {child?.children?.length > 0 ? (
                                    <a
                                        onClick={() =>
                                            toggleClasses(`${parentIndex}-${childIndex}-${index}`)
                                        }
                                    >
                                        {/* Default to Add icon when not in openIndices */}
                                        {openIndices[`${parentIndex}-${childIndex}-${index}`] ? (
                                            <span className="closeCollap">
                                                <GrFormSubtract />
                                            </span>
                                        ) : (
                                            <span className="openCollap">
                                                <GrFormAdd />
                                            </span>
                                        )}
                                        <p className="post_cls">{child?.name} (
                                            {
                                                child.children.filter(
                                                    (subChild) => subChild.is_deleted === 0
                                                ).length
                                            }
                                            ) </p>
                                    </a>
                                ) : (
                                    <div className="subCategory_sub_item">
                                        <span>{child.name}</span>
                                        {child?.is_manual === 1 && (
                                            <span className="edit_delet_cont">
                                                <span
                                                    className="edit_sub_category_item"
                                                // onClick={() =>
                                                //     handleEdit(
                                                //         category?._id,
                                                //         subItem?._id,
                                                //         child?._id,
                                                //         {
                                                //             cat_name: category.name,
                                                //             sub_cat_name: subItem.name,
                                                //             account: child,
                                                //         }
                                                //     )
                                                // }
                                                >
                                                    <MdOutlineEdit />
                                                </span>
                                                <span
                                                    className="delete_sub_category_item"
                                                    onClick={() =>
                                                        chartOfAccountDeleteFunction(child?._id)
                                                    }
                                                >
                                                    <button disabled={deleteDisabled}>
                                                        <RiDeleteBin5Line />
                                                    </button>
                                                </span>
                                            </span>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* Independent children rendering */}
                            {openIndices[`${parentIndex}-${childIndex}-${index}`] &&
                                child?.children?.length > 0 &&
                                renderNestedChildren(
                                    child.children,
                                    category,
                                    child,
                                    parentIndex,
                                    index
                                )}
                        </li>
                    ) : null
                )}
            </ul>
        );
    };

    return (
        <>
            <ButtonHeading
                title="Chart Of Account"
            // onClick={() => setIsOpen(!isOpen)}
            // buttonTitle="Add Account"
            />

            {/* Collapse tab section */}
            <div className="_chrt_mainBg" style={{padding: chartOfAccountList && chartOfAccountList.length > 0 ? "16px 20px" : "0"}}>
                <div className="_allColapse_bx">
                    {chartOfAccountList && chartOfAccountList.length > 0 ? (
                        chartOfAccountList
                            .filter((category) => category?.is_deleted !== 1)
                            .map((category, index) => (
                                <div className="otrCollapse_bx" key={index}>
                                    <div className="tileTitle">
                                        {category?.name}

                                        {category?.is_manual === 1 && (
                                            <span className="edit_delet_cont">
                                                <span
                                                    className="edit_sub_category_item"
                                                // onClick={() =>
                                                //     handleEdit(category?.id, null, null, {
                                                //         cat_name: category.name,
                                                //         sub_cat_name: null,
                                                //         account: category,
                                                //     })
                                                // }
                                                >
                                                    <MdOutlineEdit />
                                                </span>
                                                <span
                                                    className="delete_sub_category_item"
                                                    onClick={() =>
                                                        chartOfAccountDeleteFunction(category?._id)
                                                    }
                                                >
                                                    <button disabled={deleteDisabled}>
                                                        <RiDeleteBin5Line />
                                                    </button>
                                                </span>
                                            </span>
                                        )}
                                    </div>

                                    {category?.data
                                        ?.filter((subItem) => subItem?.is_deleted !== 1)
                                        ?.map((subItem, subIndex) =>
                                            subItem.status === 1 ? (
                                                <div
                                                    className={`tileData ${(openIndices[index] || []).includes(subIndex)
                                                        ? "_toggleData"
                                                        : ""
                                                        }`}
                                                    key={subIndex}
                                                >
                                                    <div className="subCategory_item_container">
                                                        {subItem?.children?.filter(
                                                            (c) => c?.is_deleted !== 1
                                                        )?.length > 0 ? (
                                                            <div className="parent-item-wrapper">
                                                                <a onClick={() => toggleClass(index, subIndex)}>
                                                                    {openIndices[index]?.includes(subIndex) ? (
                                                                        <span className="closeCollaps">
                                                                            <GrFormSubtract />
                                                                        </span>
                                                                    ) : (
                                                                        <span className="openCollaps">
                                                                            <GrFormAdd />
                                                                        </span>
                                                                    )}
                                                                    {subItem?.name} (
                                                                    {
                                                                        subItem?.children.filter(
                                                                            (child) => child.status === 1
                                                                        ).length
                                                                    }
                                                                    )
                                                                </a>

                                                                {subItem?.is_manual === 1 && (
                                                                    <span className="edit_delet_cont">
                                                                        <span
                                                                            className="edit_sub_category_item"
                                                                            onClick={() =>
                                                                                handleEdit(
                                                                                    category?.id,
                                                                                    subItem?.id,
                                                                                    null,
                                                                                    {
                                                                                        cat_name: category.name,
                                                                                        sub_cat_name: subItem.name,
                                                                                        account: subItem,
                                                                                    }
                                                                                )
                                                                            }
                                                                        >
                                                                            <MdOutlineEdit />
                                                                        </span>
                                                                        <span
                                                                            className="delete_sub_category_item"
                                                                            onClick={() =>
                                                                                chartOfAccountDeleteFunction(
                                                                                    subItem._id
                                                                                )
                                                                            }
                                                                        >
                                                                            <button disabled={deleteDisabled}>
                                                                                <RiDeleteBin5Line />
                                                                            </button>
                                                                        </span>
                                                                    </span>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <div className="subCategory_item">
                                                                <span className="subCategory_item">
                                                                    {subItem.name}
                                                                </span>
                                                                {subItem?.is_manual === 1 && (
                                                                    <span className="edit_delet_cont">
                                                                        <span
                                                                            className="edit_sub_category_item"
                                                                            onClick={() =>
                                                                                handleEdit(
                                                                                    category?.id,
                                                                                    subItem?.id,
                                                                                    null,
                                                                                    {
                                                                                        cat_name: category.name,
                                                                                        sub_cat_name: subItem.name,
                                                                                        account: subItem,
                                                                                    }
                                                                                )
                                                                            }
                                                                        >
                                                                            <MdOutlineEdit />
                                                                        </span>
                                                                        <span
                                                                            className="delete_sub_category_item"
                                                                            onClick={() =>
                                                                                chartOfAccountDeleteFunction(
                                                                                    subItem?._id
                                                                                )
                                                                            }
                                                                        >
                                                                            <button disabled={deleteDisabled}>
                                                                                <RiDeleteBin5Line />
                                                                            </button>
                                                                        </span>
                                                                    </span>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    {subItem?.children &&
                                                        subItem.children.filter((c) => c?.is_deleted !== 1) // Filter children
                                                            .length > 0 &&
                                                        renderNestedChildren(
                                                            subItem.children.filter(
                                                                (c) => c?.is_deleted !== 1
                                                            )
                                                        )}
                                                </div>
                                            ) : null
                                        )}
                                </div>
                            ))
                    ) : (
                        <>
                            <div style={{ minHeight: 'calc(100vh - 109px)', backgroundColor: '#fff' }} className='w-100 position-relative justify-content-center align-items-center d-flex'>
                                <Loading />
                            </div>
                        </>
                    )}
                </div>
            </div>

            {isOpen
                && (
                    <AddChartAccountModal {...AddChartOfAccountModal} />
                )
            }

        </>
    );
};

export default ChartOfAccount;